import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles, MenuItem, ListItemText, ClickAwayListener, Grow, Paper, Popper } from '@material-ui/core';
import CustomButton from '../../../../common/components/UI/Button/Button';
import { translate } from 'react-i18next';
import { workplanTableBody } from '../../../styles/workplanStyles';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPause, faStop, faPen } from '@fortawesome/pro-solid-svg-icons';

const styles = theme => (workplanTableBody(theme));

class ShiftLineOptionsMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    handleClose = () => {
        const { open } = this.state;

        this.setState({ open: !open });
    }

    handleAction = (action, shiftLine) => {
        const { handleShiftLineActions } = this.props;
        const { open } = this.state;

        this.setState({ open: !open });
        handleShiftLineActions(action, shiftLine);
    }

    genMenuItems = (action, shiftLine) => {
        const { accessProfiles, t } = this.props;

        const StyledMenuItem = withStyles((theme) => ({
            root: {
                '&:focus': {
                    backgroundColor: theme.palette.primary.main,
                    '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                        color: theme.palette.common.white,
                    },
                },
                textAlign: 'center'
            },
        }))(MenuItem);

        return <StyledMenuItem>
            <ListItemText
                disabled={!accessProfiles.manageShiftlines}
                onClick={() => { this.handleAction(action, shiftLine) }}
                primary={t('workPlanView.global.' + action)}
            />
        </StyledMenuItem>
    }

    render() {
        const { buttonIcon, anchorRef, classes, t, handleShiftLineActions, shiftLineData, accessProfiles, isAsyncTaskProcessing } = this.props;
        const { open } = this.state;

        const shiftlinePauseState = shiftLineData.pauseStates.length > 0;
        const shiftlineStopState = shiftLineData.stopStates.length > 0;
        return (
            <React.Fragment>
                <span
                    className={classes.ButtonChip}
                    onClick={() => { this.setState({ open: !open }) }}>
                    {buttonIcon}
                </span>
                <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    placement={'bottom-start'}
                    transition
                    className={classes.popoverSlOptions}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom' ? 'center top' : 'right bottom',
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={this.handleClose}>
                                    <div className={classes.menuActions}>
                                        <div className={classes.menuHeaderActions}>
                                            <CustomButton
                                                onClick={() => { shiftlinePauseState ? handleShiftLineActions('EditPauseShiftLine', shiftLineData) : handleShiftLineActions('PauseShiftLine', shiftLineData) }}
                                                // onClick={() => { handleShiftLineActions((shiftLineData.pauseStates.length > 0 ? 'Edit' : '') + 'PauseShiftLine', shiftLineData) }}
                                                variant="contained"
                                                size="small"
                                                color="secondary"
                                                className={classes.buttonHeaderAction}
                                                disabled={shiftLineData.states.length === 0
                                                    || !accessProfiles.manageShiftlines
                                                    || isAsyncTaskProcessing
                                                }
                                            >
                                                {/* {<FontAwesomeIcon icon={shiftLineData.pauseStates.length > 0 ? faPen : faPause} />} */}
                                                {<FontAwesomeIcon icon={shiftlinePauseState ? faPen : faPause} />}
                                                <div className={classes.divButtonAction}>{t('workPlanView.global.pause')}</div>
                                            </CustomButton>
                                            <CustomButton
                                                onClick={() => { shiftlineStopState ? handleShiftLineActions('EditStopShiftLine', shiftLineData) : handleShiftLineActions('StopShiftLine', shiftLineData) }}
                                                variant="contained"
                                                size="small"
                                                color="secondary"
                                                className={classes.buttonHeaderAction}
                                                disabled={shiftLineData.states.length === 0 || !accessProfiles.manageShiftlines || isAsyncTaskProcessing}
                                            >
                                                {<FontAwesomeIcon icon={shiftlineStopState ? faPen : faStop} />}
                                                <div className={classes.divButtonAction}>{t('workPlanView.global.stop')}</div>
                                            </CustomButton>
                                        </div>
                                        {shiftLineData.states.length === 0 ?
                                            <div className={classes.menuOtherActions}>
                                                {shiftLineData.states.length === 0 ? this.genMenuItems('ManageShiftLine', shiftLineData) : ''}
                                                {/* {this.genMenuItems('ChangeTemplate')}
                                            {this.genMenuItems('EditTemplate')}
                                            {this.genMenuItems('DuplicateTemplate')}
                                            {this.genMenuItems('RemoveTemplate')} */}
                                            </div>
                                            : ''}
                                    </div>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </React.Fragment >
        )
    }
}

const mapStateToProps = state => {
    return {
        accessProfiles: state.accessProfiles,
    }
}

export default connect(mapStateToProps)(translate('workplanManager')(withStyles(styles)(ShiftLineOptionsMenu)));